import cohortActions from "./cohortActions";
import enrollmentCountActions from "./enrollmentCountActions";
import sectionActions from "./sectionActions";
import majorContentActions from "./majorContentActions";
import cancerInfoActions from "./cancerInfoActions";
import mortalityActions from "./mortalityActions";
import dataLinkageActions from "./dataLinkageActions";
import cohortErrorActions from "./cohortErrorActions";
import majorContentErrorActions from "./majorContentErrorActions";
import enrollmentCountErrorActions from "./enrollmentCountErrorActions";
import specimenActions from "./specimenActions";
import specimenErrorActions from "./specimenErrorActions";
import cohortIDAction from "./cohortIDAction";
export default {
  cohortActions,
  enrollmentCountActions,
  sectionActions,
  majorContentActions,
  cancerInfoActions,
  mortalityActions,
  dataLinkageActions,
  cohortErrorActions,
  enrollmentCountErrorActions,
  majorContentErrorActions,
  specimenActions,
  specimenErrorActions,
  cohortIDAction,
};
